import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SearchMapComponent } from '../../components/search-map/search-map.component';

@Component({
  selector: 'app-suggestion-search',
  templateUrl: './suggestion-search.page.html',
  standalone: true,
  imports: [SearchMapComponent, TranslateModule],
})
export class SuggestionSearchPage implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  suggest() {
    this.router.navigate(['onboarding', 'suggestion', 'list'], {
      replaceUrl: true,
    });
  }

  complete() {
    this.router.navigate([''], { replaceUrl: true });
  }

  skip() {
    this.router.navigate([''], { replaceUrl: true });
  }
}
